<template>
  <d-table class="mt-10" :data="newData" :loading="loadingData" paginated backend-pagination :total="total" backend-search backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" show-search :per-page="pagination.pageSize" :search.sync="filter" @page-change="page => pagination.page = page" @sort.native="onSort">
    <template #action-buttons>
      <div class="text-primary-500 mr-3">
        Questions
      </div>
    </template>
    <template #action-buttons-right>
      <div class="flex-grow flex justify-end ">
        <div class="px-5">
          <d-btn class="bg-secondary-500" @click="launchTestQuestionModal">
            + Add Question
          </d-btn>
        </div>
      </div>
    </template>
    <template slot-scope="props">
      <d-table-column field="citation" :row="props.row" label="Citation" sortable>
        {{ props.row.citation }}
      </d-table-column>
      <d-table-column field="pageNumber" :row="props.row" label="Page Number" sortable>
        {{ props.row.pageNumber }}
      </d-table-column>
      <d-table-column field="content" :row="props.row" label="Content" sortable>
        {{ props.row.content }}
      </d-table-column>
      <d-table-column class="text-center">
        <div class="flex">
          <d-icon icon="edit" class="cursor-pointer text-lg text-green-500 ml-4" @click.native="launchTestQuestionModal(props.row)" />
          <d-icon icon="trash" class="cursor-pointer text-lg text-red-500 ml-4" @click.native="setTestQuestionToInactive(props.row)" />
        </div>
      </d-table-column>
    </template>
  </d-table>
</template>
<script>
  import axios from 'axios';
  import TestQuestionModal from './TestQuestionModal';
  export default {
    parent: this,
    props: {
      testSectionId: {
        type: Number,
        default: () => null,
      },
    },
    data: () => ({
      newData: [],
      total: 0,
      filter: '',
      sectionId: '',
      loadingData: false,
      pagination: {
        page: 1,
        pageSize: 10,
        sortField: 'createdAt',
        sortOrder: 'desc',
      },
    }),
    watch: {
      pagination: {
        handler() {
          this.getAnswersForQuestions();
        },
        deep: true,
      },
      filter() {
        this.getAnswersForQuestions();
      },
    },
    mounted() {
      this.sectionId = this.testSectionId;
      this.getAnswersForQuestions();
    },

    methods: {
      async getAnswersForQuestions() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `filter=${this.filter}`, `sectionId=${this.sectionId}`].join('&');

        this.loadingData = true;
        const { data } = await axios.get(`/api/testQuestions/paged?${params}`);

        this.newData = data.resultItems;
        this.total = data.totalRecords;
        this.loadingData = false;
      },


      launchTestQuestionModal(question) {
        this.$modal.open({
          parent: this,
          width: 1200,
          height: 1200,
          component: TestQuestionModal,
          hasModalCard: true,
          props: {
            testQuestion: question,
            testSectionId: this.testSectionId,
          },
          events: {
            getAnswersForQuestions: () => this.getAnswersForQuestions(),
          },
        });
      },

      setTestQuestionToInactive(testQuestion) {
        this.$dialog.confirm({
          title: 'Deleting Test Question',
          message: `Are you sure you want to delete <b>${testQuestion.name}</b>? This action cannot be undone.`,
          confirmText: 'Delete Test Question',
          confirmColor: 'error',
          onConfirm: async () => {
            await axios.delete(`/api/testQuestions/${testQuestion.id}`);
            await this.getAnswersForQuestions();
            this.$toast.open({
              message: 'Test Question was deleted',
              color: 'success',
            });
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },


  };
</script>